import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export interface ModalPopupProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subTitle?: string;
  children?: React.ReactNode;
  childrenAction?: React.ReactNode;
  style?: React.CSSProperties;
  onNavigate?: () => void; // optional for backward compatibility
  isOtpModal?: boolean;
}

const ModalPopup: React.FC<ModalPopupProps> = ({
  isOpen,
  onClose,
  title,
  subTitle,
  children,
  childrenAction,
  style,
  isOtpModal,
}) => {
  const handleClose = (
    _event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason === "backdropClick") return;
    onClose();
  };

  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          borderRadius: "8px",
          ...style, // merge any custom styles
        },
      }}
    >
      {!isXsOrSm && !isOtpModal && (
        <Box sx={{ paddingTop: "20px" }}>{childrenAction}</Box>
      )}

      <Typography
        variant="subtitle1"
        sx={{
          fontSize: "15px",
          fontWeight: 600,
          lineHeight: "24.2px",
          letterSpacing: "-0.5px",
          color: "#616161",
          mx: 2,
          pt: isXsOrSm ? 2 : 0,
        }}
      >
        {title}
      </Typography>

      {/* Title section */}
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          paddingBottom: 1,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "24.2px",
            letterSpacing: "-0.5px",
            color: "#00B3B5",
          }}
        >
          {subTitle}
        </Typography>

        {title?.toLowerCase()?.includes("provisional offer") ? (
          <></>
        ) : (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "#616161",
              pb: isXsOrSm ? 1 : 0,
            }}
          >
            <Close />
          </IconButton>
        )}
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ px: isXsOrSm ? 3 : 2 }}>{children}</DialogContent>

      {/* Optional Actions (e.g. buttons) */}
      {childrenAction && (
        <DialogActions
          sx={{
            pt: 2,
            justifyContent: "center",
          }}
        >
          {childrenAction}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ModalPopup;
